// extracted by mini-css-extract-plugin
export default {"container":"Cars_container__NED3h","boxActivities":"Cars_boxActivities__ReDhC","boxInfo":"Cars_boxInfo__XkuUP","boxBtn":"Cars_boxBtn__MDA0e"};